import { Routes, Route } from "react-router-dom";
import FcdNetworkPage from '../features/fcd-network';
import SimFix from '../features/simfix';
import Analysis from "../features/od-analysis";
import SignalFix from '../features/signal-fix';
import AssignxPage from '../features/assignx';
import MysteryClient from '../features/mystery-client';
import Semafix from '../features/semafix';
import RequireService from './RequireService';
import { SERVICE_KEYS } from '../constants/services';

function Router() {
  return (
    <Routes>
      {/* The main map is the landing page and the fallback for guarded routes,
          so it stays reachable whatever the user's module permissions are. */}
      <Route path="/" element={<FcdNetworkPage />} />
      <Route
        path="/simfix"
        element={<RequireService service={SERVICE_KEYS.simfix_areas}><SimFix /></RequireService>}
      />
      <Route
        path="/analysis"
        element={<RequireService service={SERVICE_KEYS.od_analysis}><Analysis /></RequireService>}
      />
      <Route
        path="/signal-fix"
        element={<RequireService service={SERVICE_KEYS.signalfix}><SignalFix /></RequireService>}
      />
      <Route
        path="/assignx"
        element={<RequireService service={SERVICE_KEYS.assignx}><AssignxPage /></RequireService>}
      />
      <Route
        path="/mystery-client"
        element={<RequireService service={SERVICE_KEYS.mystery_client}><MysteryClient /></RequireService>}
      />
      <Route
        path="/semafix"
        element={<RequireService service={SERVICE_KEYS.semafix}><Semafix /></RequireService>}
      />
    </Routes>
  )
}

export default Router
